import { SentryErrorComponent } from '@components/Fallback'
import { Operations } from '@lib/permissions'
import CheckPermissionsWrapper from '@lib/permissions/CheckPermissionsWrapper'
import { Permission } from '@lib/permissions/Permission'
import { createFileRoute, Outlet } from '@tanstack/react-router'

const mediaLibraryReadPermission = new Permission(
  ['mediaLibrary'],
  Operations.Read
)

const MediaLibraryBaseRoute = () => (
  <CheckPermissionsWrapper permissions={[mediaLibraryReadPermission]}>
    <Outlet />
  </CheckPermissionsWrapper>
)

export const Route = createFileRoute('/_auth/o/$orgId/mediaLibrary')({
  component: MediaLibraryBaseRoute,
  loader: async () => ({
    crumb: 'Media Library',
  }),
  errorComponent: SentryErrorComponent,
})
